module.exports = __webpack_public_path__ + "img/title+@3x.bb7ddebb.png";